<template>
  <a href="#" class="store_box" @click.prevent="$emit('select:storeItem', item)">
    <base-image :src="itemImage"></base-image>

    <div class="flex-column">
      <p class="title">
        <b v-if="isBonusPhaseEnabledAndValid" class="strikethrough">{{ preBonusPhaseNumberOfGames }}</b>
        {{ numberOfGames }} {{ $_getTranslations.home_store_games }}
      </p>

      <p class="desc">
        <template v-if="hasPoints">
          {{ $_getTranslations.home_store_store_item_description_pt1 }}
          <span>{{ points }}</span>
          {{ $_getTranslations.home_store_store_item_description_pt2 }}
        </template>
      </p>

      <div class="flex-row">
        <p class="price">{{ price }}</p>
      </div>
    </div>
  </a>
</template>

<script>
import BaseImage from '../../../common/image/BaseImage'
import translationMixin from '../../../../common/mixins/translation'
import {isPositiveNumber} from '../../../../helpers/common'

export default {
  name: 'StoreListItem',
  components: {BaseImage},
  emits: ['select:storeItem'],
  mixins: [translationMixin],
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    bonusPhaseEnabled: {
      type: Boolean,
      default: false
    },
    bonusPhaseAmount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    isBonusPhaseEnabledAndValid() {
      return this.bonusPhaseEnabled && isPositiveNumber(this.bonusPhaseAmount)
    },
    itemImage () {
      return this.isBonusPhaseEnabledAndValid
        ? '/static/images/books.png'
        : '/static/images/book.png'
    },
    preBonusPhaseNumberOfGames () {
      return (this.isBonusPhaseEnabledAndValid)
        ? (this.item.noOfGames / this.bonusPhaseAmount)
        : this.item.noOfGames
    },
    numberOfGames () {
      return this.item.noOfGames
    },
    points () {
      return this.item.points
    },
    price () {
      return `${this.item.price} ${this.item.currencyCode}`
    },
    hasPoints () {
      return isPositiveNumber(this.points)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/store/item/StoreListItem.vue